import {ROOT_URL} from '../../config';
import request from '../../components/api/api';
import {toastr} from 'react-redux-toastr';
import {
    fetchedSitesLanguages,
    updatedSitesLanguages
} from './actions';

export function fetchSitesLanguages() {
    return dispatch => {
        let options = {
            url: `${ROOT_URL}/sites?_embed=languages`,
            method: 'GET'
        };
        return request(options, dispatch)
            .then(response => dispatch(fetchedSitesLanguages(response.data)));
    };
}

export function updateSitesLanguages(sitesLanguages) {
    return dispatch => {

        let sitesLanguagesToUpdate = {};
        sitesLanguages.forEach((languages, siteId) => {
            let langs = [];
            Object.keys(languages).forEach((languageId) => {
                if (languages[languageId]) {
                    langs.push(languageId);
                }
            });
            sitesLanguagesToUpdate[siteId] = langs;
        });

        let options = {
            url: `${ROOT_URL}/sites-languages`,
            method: 'PUT',
            data: sitesLanguagesToUpdate
        };

        return request(options, dispatch)
            .then(response => dispatch(updatedSitesLanguages(response.data)))
            .then(() => toastr.success('Success!', 'Sites languages have been updated.'));
    };
}


// WEBPACK FOOTER //
// ./src/containers/configuration/thunks.js